import { inject, Pipe, PipeTransform } from '@angular/core';
import { AbstractControl, ValidationErrors } from '@angular/forms';

import { ErrorMessage } from '../../../interfaces';
import { ValidateFieldsService } from './../../fields/validate-fields.service';

@Pipe({
  name: 'firstErrorMessage',
  standalone: true,
})
export class FirstErrorMessagePipe implements PipeTransform {
  private _validateField = inject(ValidateFieldsService);

  transform(hasErrors: ValidationErrors, formControl: AbstractControl | null, errorMessages: ErrorMessage[]): string | null {
    if (!hasErrors || !formControl || !errorMessages?.length) {
      return null;
    }

    for (const { error, message } of errorMessages) {
      if (this._validateField.hasErrorValidate(formControl, error)) {
        return message;
      }
    }

    return null;
  }
}
